import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import NewsCard from "../../news/NewsCard";
import { News } from "../../../compilers/news/News";
import { t } from "i18next";
import Skeleton from "react-loading-skeleton";
import chevron from "../../../assets/chevron.svg";

type PaginatedNewsListProps = {
  news: News[];
  currentPage: number;
  nextPage: () => void;
  previousPage: () => void;
};

const PaginatedNewsList: React.FC<PaginatedNewsListProps> = ({
  news,
  currentPage,
  nextPage,
  previousPage,
}) => {
  const [paginatedNews, setPaginatedNews] = useState<News[]>([]);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const { ready } = useTranslation();

  const getPageCount = () => {
    if (news && news.length) {
      const pageCount = Math.ceil(news.length / 12);
      if (pageCount === 0) {
        return 1;
      }
      return pageCount;
    }
    return 1;
  };

  useEffect(() => {
    //scrollToTop();
    if (news && news.length) {
      if (currentPage === 1) {
        setPaginatedNews(news.slice(0, 12));
      } else if (currentPage === 2) {
        setPaginatedNews(news.slice(12, 24));
      } else {
        setPaginatedNews(news.slice(currentPage * 12, currentPage * 12 + 12));
      }
    }
  }, [currentPage, news]);

  const getCurrentPage = () => {
    return paginatedNews.map((item: News) => {
      return <NewsCard key={item.id} news={item} />;
    });
  };

  return (
    <>
      <div className="news-card-container my-2">{getCurrentPage()}</div>
      <div className="pagination-buttons-container">
        <div
          className="d-flex"
          style={{
            margin: "0 1rem",
          }}
        >
          <div>{currentPage}</div>
          <div style={{ margin: "0 5px" }}>
            {ready ? `${t("button.of")}` : <Skeleton />}
          </div>{" "}
          <div>{getPageCount()}</div>
        </div>
        <button
          className={`p2 btn btn-square prev-btn ${
            currentPage === 1 ? "faint-yellow" : ""
          }`}
          disabled={currentPage === 1}
          onClick={() => {
            scrollToTop();
            previousPage();
          }}
        >
          <img className="chevron-back" src={chevron} alt="back" />
        </button>{" "}
        <button
          className={`p2 btn btn-square ${
            currentPage === getPageCount() ? "faint-yellow" : ""
          }`}
          disabled={currentPage === getPageCount()}
          onClick={() => {
            scrollToTop();
            nextPage();
          }}
        >
          <img className="chevron-next" src={chevron} alt="next" />
        </button>
      </div>
    </>
  );
};

export default PaginatedNewsList;
